import { InfoBox } from "@/components/common/InfoBox";
import { useDiaryByIdQuery } from "@/features/diaries/api";
import History from "@/features/diaries/features/history/components/History";
import NoHistory from "@/features/diaries/features/history/components/NoHistory";
import { collateDiaryHistory } from "@/features/diaries/services/collateDiaryHistory";
import { hooks as h } from "@/hooks";
import { createFileRoute } from "@tanstack/react-router";
import { History as HistoryIcon } from "lucide-react";

const HistoryPage = () => {
	const { diaryId } = Route.useParams();
	const { data: diary } = useDiaryByIdQuery(diaryId);
	h.useNav([
		{ label: "Diaries", route: { to: "/diaries" } },
		{
			route: { to: "/diaries/$diaryId/home/history" },
			label: "History",
			options: [
				{ route: { to: "/diaries/$diaryId/home/new" }, label: "New" },
				{ route: { to: "/diaries/$diaryId/home/history" }, label: "History" },
				{ route: { to: "/diaries/$diaryId/home/charts" }, label: "Charts" },
			],
		},
	]);

	if (!diary) {
		return null;
	}

	return (
		<>
			<NoHistory diary={diary} />
			<History
				size="sm"
				editable={true}
				diaryId={diaryId}
				diaryHistory={collateDiaryHistory(diary)}
			/>
		</>
	);
};

export const Route = createFileRoute("/_app/diaries/$diaryId/home/history")({
	component: HistoryPage,
});
